import React from "react";
import Welcome from "../component/sections/Welcome";
import cookie from "js-cookie";
import NotFounded from "../component/partials/other/NotFounded";
import UnAuthorized from "../component/partials/other/UnAuthorized";
import userRoutes from "./user";
import manageUserRoutes from "./manage-user";
import authRoutes from "./auth";
import roleRoutes from "./roles";
import ticketRoutes from "./tickets";
import sitePublisherRoutes from "./site-publisher";
import permissionRoutes from "./permission";
import campaignRoutes from "./campaigns";
import advertiseRoutes from "./advertise";
import reportRoutes from "./report";
import financeRoutes from "./finance";
import pageRoutes from "./page";
import tagPositions from "./position";
import middleware from "./middlewares/middleware";
import manageDiscount from "./manage-discount";
import manageCampaigns from "./manage-campaigns";
import coworkerCampaigns from "./coworker-campaigns";
import coworkerAdvertise from "./coworker-advertise";
import actionCookie from "../helpers/action-cookie";
import helpRoutes from "./help";

const routes = [
  {
    path: "/",
    render: () => {
      return middleware(["isUserLogin"], <Welcome />);
    },
    exact: true,
  },
  ...authRoutes,
  ...manageUserRoutes,
  ...userRoutes,
  ...roleRoutes,
  ...permissionRoutes,
  ...ticketRoutes,
  ...sitePublisherRoutes,
  ...campaignRoutes,
  ...manageCampaigns,
  ...coworkerCampaigns,
  ...advertiseRoutes,
  ...reportRoutes,
  ...financeRoutes,
  ...pageRoutes,
  ...tagPositions,
  ...manageDiscount,
  ...coworkerAdvertise,
  ...helpRoutes,
  {
    path: "/unauthorized",
    render: () => <UnAuthorized />,
    exact: true,
  },
  {
    path: "*",
    render: () => <NotFounded />,
    exact: true,
  },
];

routes.forEach((route) => {
  route.render = (function () {
    var cached_function = route.render;

    return function () {
      const result = cached_function.apply(this, arguments);
      cookie.set(
        actionCookie.PREVIOUS_PAGE_URL,
        cookie.get(actionCookie.CURRENT_PAGE_URL)
      );
      cookie.set(actionCookie.CURRENT_PAGE_URL, window.location.pathname);
      return result;
    };
  })();
});

export default routes;
